import { useEffect, useState } from "react";
import { Reseller } from "../../models/Reseller";
import { Button, message, Table } from "antd";
import { ResellerFormModal } from "./ResellerFormModal";
import { fetchResellers } from "../../redux/slices/resellerSlice";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { AssignPackagesModal } from "../packages/AssignPackagesModal";

export function ResellersList() {
  const [modalVisible, setModalVisible] = useState(false);
  const [editingReseller, setEditingReseller] = useState<Reseller | null>(null);
  const dispatch = useDispatch<AppDispatch>();
  const { resellers, loading, error } = useSelector(
    (state: RootState) => state.resellers
  );
  const [assignPackagesModalVisible, setAssignPackagesModalVisible] =
    useState(false);
  const [assigningResellerId, setAssigningResellerId] = useState<number | null>(
    null
  );

  const openAssignPackagesModal = (resellerId: number) => {
    console.log(resellerId);
    setAssigningResellerId(resellerId);
    setAssignPackagesModalVisible(true);
  };
  useEffect(() => {
    dispatch(fetchResellers());
  }, [dispatch]);

  const handleCreate = () => {
    setEditingReseller(null);
    setModalVisible(true);
  };

  const handleEdit = (reseller: Reseller) => {
    setEditingReseller(reseller);
    setModalVisible(true);
  };

  return (
    <div style={{ padding: 24 }}>
      <Button
        type="primary"
        onClick={handleCreate}
        style={{ marginBottom: 16 }}
      >
        Create Reseller
      </Button>
      <Table
        dataSource={resellers}
        rowKey="id"
        loading={loading}
        columns={[
          { title: "First Name", dataIndex: "firstName" },
          { title: "Last Name", dataIndex: "lastName" },
          { title: "Username", dataIndex: "username" },
          { title: "Email", dataIndex: "email" },
          {
            title: "Admin",
            dataIndex: "isAdmin",
            render: (val) => (val ? "Yes" : "No"),
          },
          {
            title: "Action",
            render: (_, record) => (
              <>
                <Button
                  type="link"
                  onClick={() => {
                    console.log(record);
                    handleEdit(record);
                  }}
                >
                  Edit
                </Button>
                {!record.isAdmin && (
                  <Button
                    type="link"
                    onClick={() => {
                      console.log(record);
                      openAssignPackagesModal(record.resellerId);
                    }}
                  >
                    Assign Packages
                  </Button>
                )}
              </>
            ),
          },
        ]}
      />
      <ResellerFormModal
        visible={modalVisible}
        onClose={() => {
          setModalVisible(false);
          fetchResellers();
        }}
        editingReseller={editingReseller}
      />
      {assigningResellerId !== null && (
        <AssignPackagesModal
          visible={assignPackagesModalVisible}
          resellerId={assigningResellerId}
          onClose={() => {
            setAssigningResellerId(null);
            setAssignPackagesModalVisible(false);
          }}
        />
      )}
    </div>
  );
}
